import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import Modal from '../../../common/modal/Modal';
import { postParcelChangeConsignee } from '../../../../actions';
import withEndpointAuthorization from '../../authorization/withEndPointAuthorization';
import { generatePostParcelChangeConsigneeCustomer } from '../../../../config/endpoints';
import { PUT } from '../../../../config/permissions';
import ChangeConsigneeCustomerForm from './ChangeConsigneeCustomerForm';

export const ChangeConsigneeCustomerButton = ({
  parcel,
  dispatchPostParcelChangeConsignee,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState(null);

  const closeModal = () => setShowModal(false);

  const onModalSubmit = async ({
    consigneeCustomerId,
    secondaryConsigneeCustomerId,
  }) => {
    const newFormValues = {
      parcelId: parcel.id,
      consigneeCustomerId: consigneeCustomerId
        ? consigneeCustomerId.value
        : null,
      secondaryConsigneeCustomerId: secondaryConsigneeCustomerId
        ? secondaryConsigneeCustomerId.value
        : null,
    };

    await dispatchPostParcelChangeConsignee(newFormValues);
    setShowModal(false);
    setModalBody(null);
  };

  const openModal = () => {
    const newModalBody = (
      <ChangeConsigneeCustomerForm
        onCancel={closeModal}
        handleProcess={onModalSubmit}
        parcel={parcel}
      />
    );
    setModalBody(newModalBody);
    setShowModal(true);
  };

  return (
    <>
      <Modal
        show={showModal}
        title="Cambiar Consignado"
        body={modalBody}
        size="lg"
      />
      <Button color="warning" onClick={openModal}>
        <i className="fa fa-user" /> Cambiar Consignado
      </Button>
    </>
  );
};

ChangeConsigneeCustomerButton.propTypes = {
  parcel: PropTypes.instanceOf(Object).isRequired,
  dispatchPostParcelChangeConsignee: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostParcelChangeConsignee: postParcelChangeConsignee,
};

const connectedComponent = connect(
  null,
  mapDispatchToProps,
)(ChangeConsigneeCustomerButton);

export default withEndpointAuthorization({
  url: generatePostParcelChangeConsigneeCustomer(0),
  permissionType: PUT,
})(connectedComponent);
